module.exports = __webpack_public_path__ + "static/zdjęcia16-ed03ebfee94b280c7cd2df68400977b7.svg";